import { render, staticRenderFns } from "./BodySensor.vue?vue&type=template&id=60f564ba&scoped=true&"
import script from "./BodySensor.vue?vue&type=script&lang=js&"
export * from "./BodySensor.vue?vue&type=script&lang=js&"
import style0 from "./BodySensor.vue?vue&type=style&index=0&id=60f564ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f564ba",
  null
  
)

export default component.exports